import React from 'react';
import SectionHead from './SectionHead';
import { EXPERIENCES } from '../data';
import { useLang } from '../LangContext';
import { useScramble } from '../hooks/useScramble';

function TimelineRow({ e, lang, nowLabel }) {
  const [company, play] = useScramble(e.company);

  return (
    <div className="tl__row" onMouseEnter={play}>
      <div className="tl__when">
        {e.when} {e.now && <span className="now">{nowLabel}</span>}
      </div>
      <div className="tl__main">
        <h3>{company}</h3>
        <div className="tl__role">{e.role[lang]}</div>
        <div className="tl__notes" dangerouslySetInnerHTML={{ __html: e.notes[lang] }} />
      </div>
      <div className="tl__tags">
        {e.tags.map((tag) => <span className="tl__tag" key={tag}>{tag}</span>)}
      </div>
    </div>
  );
}

export default function Timeline() {
  const { lang, t } = useLang();

  return (
    <section className="s fullpage-section" id="exp">
      <div className="s__inner">
        <SectionHead label={t.timeline.label} title={t.timeline.title} />
        <div className="tl">
          {EXPERIENCES.map((e, i) => (
            <TimelineRow e={e} lang={lang} nowLabel={t.timeline.now} key={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
